import React from "react";
import { useVoice } from "../context/VoiceContext";
import { Volume2, VolumeX, Radio } from "lucide-react";

export default function VoiceBar() {
  const v = useVoice();
  if (!v) return null;
  const { voices, voiceId, setVoiceId, muted, setMuted, autoSpeak, setAutoSpeak, speaking, stop } = v;

  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="voice-bar">
      <button onClick={() => setMuted(!muted)} data-testid="voice-mute-toggle"
        className={`flex items-center gap-2 px-3 py-2 border font-mono-ui text-[11px] uppercase tracking-wider transition ${
          muted ? "border-zinc-800 text-zinc-500" : "border-[color:var(--gio-primary)] text-[color:var(--gio-primary)]"
        }`}>
        {muted ? <VolumeX size={14} /> : <Volume2 size={14} />} {muted ? "Muted" : "Sound on"}
      </button>

      <label className="flex items-center gap-2 px-3 py-2 border border-zinc-800 font-mono-ui text-[11px] uppercase tracking-wider text-zinc-400 cursor-pointer">
        <input type="checkbox" checked={autoSpeak} onChange={(e) => setAutoSpeak(e.target.checked)}
          data-testid="voice-autospeak-toggle"
          className="accent-[color:var(--gio-primary)]" />
        Auto-speak
      </label>

      <select value={voiceId} onChange={(e) => setVoiceId(e.target.value)}
        data-testid="voice-picker"
        className="bg-black border border-zinc-800 text-zinc-300 font-mono-ui text-[11px] uppercase tracking-wider px-2 py-2 focus:border-[color:var(--gio-primary)] outline-none">
        <option value="">Default</option>
        {voices.map((v) => (
          <option key={v.voice_id} value={v.voice_id}>{v.name}</option>
        ))}
      </select>

      {speaking && (
        <button onClick={stop} data-testid="voice-stop-button"
          className="flex items-center gap-2 px-3 py-2 border border-[color:var(--gio-primary)] bg-[color:var(--gio-primary)]/10 text-[color:var(--gio-primary)] font-mono-ui text-[11px] uppercase tracking-wider animate-pulse">
          <Radio size={14} /> Speaking · stop
        </button>
      )}
    </div>
  );
}
